import type { ReactNode } from "react";

type HeadlineAccentProps = {
  children: ReactNode;
  className?: string;
};

export function HeadlineAccent({ children, className = "" }: HeadlineAccentProps) {
  return <span className={`font-serif italic text-[#c99422] ${className}`.trim()}>{children}</span>;
}
